



























































import { Prop, Component, Vue } from "vue-property-decorator";
import AbcList from "./AbcList.vue";
import AbcNoDataFound from "../alert/AbcNoDataFound.vue";
import AbcToolButton from "../button/AbcToolButton.vue";
import AbcAccordion from "../accordion/AbcAccordion.vue";

interface GroupArray {
    0: string; //tag
    1: unknown[];
}

@Component({
    components: {
        AbcList,
        AbcNoDataFound,
        AbcToolButton,
        AbcAccordion,
    },
})
export default class AbcGroupedList extends Vue {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    @Prop() private items!: any[];
    @Prop() private tag!: string;
    @Prop({ type: Boolean }) hideNoData!: boolean;
    @Prop() selectedItem!: unknown | unknown[];
    @Prop() openTags!: string[];
    @Prop({ type: Boolean }) isCollapsable!: boolean;
    @Prop({ type: Boolean }) onlyOneOpen!: boolean;
    @Prop({ type: Boolean }) withoutSelection!: boolean;
    @Prop({ type: Boolean }) hideCheckbox!: boolean;
    @Prop() customLiClass!: string;
    @Prop() itemId!: string;

    private get refOpenTags() {
        const temp: Record<string, boolean> = {};
        this.items.forEach((d) => {
            temp[d[this.tag]] = this.openTags.includes(d[this.tag]) ? true : false;
        });
        return temp;
    }

    private updateOpenTags(item: string, val: boolean) {
        let res: string[] = [];
        if (this.onlyOneOpen) {
            res = val ? [item] : [];
        } else {
            res = [...this.openTags];
            if (val) {
                res.push(item);
            } else {
                res = res.filter((t) => t !== item);
            }
        }

        this.$emit("update:openTags", res);
    }

    private get groups(): GroupArray[] | null {
        const res = new Map();
        if (!this.items) {
            return null;
        }

        this.items.forEach((d) => {
            res.set(d[this.tag], []);
        });

        this.items.forEach((d) => {
            res.get(d[this.tag]).push(d);
        });
        return Array.from(res.entries());
    }

    onSelect(item: unknown) {
        this.$emit("select", item);
    }
}
